import type { CatalogBadgeTone } from '@/shared/components/catalog/CatalogBadge'

const LISTING_STATUS_TONE: Record<string, CatalogBadgeTone> = {
  draft: 'muted',
  pending_platform: 'amber',
  published: 'success',
  sold: 'violet',
  offline: 'muted',
  rejected: 'rose',
}

/** @deprecated 使用 listingStatusTone + CatalogBadge */
export function listingStatusClass(_status: string): string {
  return ''
}

export function listingStatusTone(status: string): CatalogBadgeTone {
  return LISTING_STATUS_TONE[status] ?? 'muted'
}

export function canEditListing(status: string): boolean {
  return status === 'draft' || status === 'rejected'
}

export function canDeleteListing(status: string, soldCount: number): boolean {
  if (soldCount > 0) return false
  return (
    status === 'draft' ||
    status === 'rejected' ||
    status === 'pending_platform' ||
    status === 'offline'
  )
}

export function canSubmitListing(status: string): boolean {
  return status === 'draft' || status === 'rejected'
}

export function canOfflineListing(status: string, soldCount: number): boolean {
  return soldCount === 0 && status === 'published'
}

export function canViewPublicListing(status: string, publicId: string): boolean {
  return !!publicId && status === 'published'
}

/** draft / 待审 / 已上架 — 视为占用当前快照，不可重复挂牌 */
export function isActiveMarketplaceListingStatus(status: string): boolean {
  return status === 'draft' || status === 'pending_platform' || status === 'published'
}
